<div class="compliance-container">
	<div class="compliance-container-inner">
		<img
			class="d-none d-md-block orange-pattern-overlay"
			src="../../assets/img/orange-pattern.png"
			alt=""
		/>
		<img
			class="d-md-none orange-pattern-overlay"
			src="../../assets/img/orange-pattern-mobile.png"
			alt=""
		/>
		<div class="container text-center">
			<h2 class="compliance-header">
				Continuous Compliance for <br class="d-none d-sm-block" />
				Financial Institutions
			</h2>

			<div class="row">
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/avoid-fines.svg"
						alt=""
					/>
					<div class="challenges-list-head">Avoid Fines</div>
					<div class="challenges-list-content">
						Ensure your paperwork is always up to date by digitizing
						your compliance artifacts and managing the entire
						control lifecycle using RegScale’s guided approach.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/alleviate-risk.svg"
						alt=""
					/>
					<div class="challenges-list-head">Alleviate Risk</div>
					<div class="challenges-list-content">
						Increase the value of cyber scanning tools through our
						APIs and update your compliance paperwork in real-time.
						Encourage teams to work collaboratively with automated
						workflows.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/create-momentum.svg"
						alt=""
					/>
					<div class="challenges-list-head">Create Momentum</div>
					<div class="challenges-list-content">
						Deploy in under an hour on any platform (on premises,
						cloud, or air-gapped) with no developers. Conquer risk
						and compliance issues across your entire organization
						with no manual reporting processes.
					</div>
				</div>
			</div>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
					Find Out More
				</button></a
			>
		</div>
	</div>
</div>
